import { useEffect, useState } from 'react';
import { autorun } from 'mobx';

/** Utility for triggering state updates on `mobx` observable updates in hooks. **NOTE**: designed solely for using
 * observables in hooks. Prefer using `mobx` store observables and `observer` HOC directly in components */
export const useObservable = <T>(
  observableFactory: () => T,
  deps: unknown[] = []
) => {
  const [state, setState] = useState(observableFactory());

  useEffect(() => {
    const unsubscribe = autorun(() => setState(observableFactory()));

    return () => unsubscribe();
  }, deps);

  return state;
};
